import React, { useEffect, useId, useState } from "react";
import "./Menu.css";

const Menu = ({
  selectedType,
  fromDate,
  toDate,
  keyword,
  isMenuOpen,
  onTypeChange,
  onFromDateChange,
  onToDateChange,
  onKeywordChange,
  onToggleMenu,
  onClearFilters,
}) => (
  <MenuContent
    selectedType={selectedType}
    fromDate={fromDate}
    toDate={toDate}
    keyword={keyword}
    isMenuOpen={isMenuOpen}
    onTypeChange={onTypeChange}
    onFromDateChange={onFromDateChange}
    onToDateChange={onToDateChange}
    onKeywordChange={onKeywordChange}
    onToggleMenu={onToggleMenu}
    onClearFilters={onClearFilters}
  />
);

const MenuContent = ({
  selectedType,
  fromDate,
  toDate,
  keyword,
  isMenuOpen,
  onTypeChange,
  onFromDateChange,
  onToDateChange,
  onKeywordChange,
  onToggleMenu,
  onClearFilters,
}) => {
  const [pendingFrom, setPendingFrom] = useState(fromDate);
  const [pendingTo, setPendingTo] = useState(toDate);
  const [pendingKeyword, setPendingKeyword] = useState(keyword);
  const panelId = useId();
  const keywordId = `${panelId}-keyword`;
  const typeId = `${panelId}-type`;
  const fromId = `${panelId}-from`;
  const toId = `${panelId}-to`;

  useEffect(() => {
    setPendingFrom(fromDate);
  }, [fromDate]);

  useEffect(() => {
    setPendingTo(toDate);
  }, [toDate]);

  useEffect(() => {
    setPendingKeyword(keyword);
  }, [keyword]);

  const commitFromDate = () => {
    if (pendingFrom !== fromDate) {
      onFromDateChange(pendingFrom);
    }
  };

  const commitToDate = () => {
    if (pendingTo !== toDate) {
      onToDateChange(pendingTo);
    }
  };

  const commitKeyword = () => {
    const trimmed = pendingKeyword.trim();
    if (trimmed !== keyword) {
      onKeywordChange(trimmed);
    }
  };

  const handleKeywordKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      commitKeyword();
    }
  };

  const handleClearFilters = () => {
    setPendingFrom("");
    setPendingTo("");
    setPendingKeyword("");
    onClearFilters();
  };

  return (
    <div className="menu-wrapper">
      <div className="menu-trigger-row">
        <button
          type="button"
          className="menu-trigger"
          onClick={onToggleMenu}
          aria-expanded={isMenuOpen}
          aria-controls={panelId}
          aria-label={isMenuOpen ? "Hide filters" : "Show filters"}
        >
          <span className="menu-trigger-icon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
        <hr className="menu-trigger-rail" aria-hidden="true" />
      </div>

      <div
        id={panelId}
        className={`menu-panel ${isMenuOpen ? "open" : ""}`}
        aria-hidden={!isMenuOpen}
      >
        <div className="filter-container">
          <div className="filter-group keyword-group">
            <label htmlFor={keywordId}>Search:</label>
            <input
              id={keywordId}
              type="text"
              value={pendingKeyword}
              onChange={(event) => setPendingKeyword(event.target.value)}
              enterKeyHint="search"
              onKeyDown={handleKeywordKeyDown}
              onBlur={commitKeyword}
            />
          </div>

          <div className="filter-group">
            <label htmlFor={typeId}>Bill Type:</label>
            <select
              id={typeId}
              value={selectedType}
              onChange={(event) => onTypeChange(event.target.value)}
            >
              <option value="all">All</option>
              <option value="presdocu">Presidential Documents</option>
              <option value="rule">Rules</option>
              <option value="notice">Notices</option>
            </select>
          </div>

          <div className="filter-group">
            <label htmlFor={fromId}>From:</label>
            <input
              id={fromId}
              type="date"
              value={pendingFrom}
              onChange={(event) => setPendingFrom(event.target.value)}
              onBlur={commitFromDate}
              max={pendingTo || undefined}
            />
          </div>

          <div className="filter-group">
            <label htmlFor={toId}>To:</label>
            <input
              id={toId}
              type="date"
              value={pendingTo}
              onChange={(event) => setPendingTo(event.target.value)}
              onBlur={commitToDate}
              min={pendingFrom || undefined}
            />
          </div>
          <div className="filter-group clear-group">
            <button type="button" className="clear-filters" onClick={handleClearFilters}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
